export const isEmptyParagraphOrString = (html?: string) => {
  const emptyParagraph = '<p>&nbsp;</p>'
  return !html || html === emptyParagraph
}
